import * as React from 'react'
import Table from '@components/table/table'
import { FloorHeatingListFilterParams } from '@modules/floor-heating/list/filter'
import { FloorHeatingListTableRow } from '@modules/floor-heating/list/table-row'
import { EnhancedFloorHeatingMeasurement, FloorHeatingAvailableZones } from '@modules/floor-heating/models'
import { useFloorHeatingAppData } from '@modules/floor-heating/use-floor-heating-app-data'

interface Props {
  measurements: EnhancedFloorHeatingMeasurement[]
  isLoading: boolean
  filters: FloorHeatingListFilterParams
  setFilters: (filters: FloorHeatingListFilterParams) => void
  selectableHeader: React.ReactElement
  selectableCell: (measurement: EnhancedFloorHeatingMeasurement) => React.ReactElement
}

export const FloorHeatingListTable: React.FC<Props> = ({
  isLoading,
  measurements,
  filters,
  setFilters,
  selectableHeader,
  selectableCell,
}) => {
  const { appData } = useFloorHeatingAppData()
  const headerValues = getHeaderValues(appData?.available_zones)

  return (
    <Table
      className="table-hover w-100"
      headerValues={headerValues}
      isLoading={isLoading}
      filters={filters}
      setFilters={setFilters}
      selectableHeader={selectableHeader}
    >
      {measurements.map(measurement => (
        <FloorHeatingListTableRow key={measurement.apartment_name} measurement={measurement}>
          {selectableCell(measurement)}
        </FloorHeatingListTableRow>
      ))}
    </Table>
  )
}

const getHeaderValues = (availableZones: FloorHeatingAvailableZones | undefined) => [
  { title: 'Id. apartamentu', sortField: 'apartment_name' },
  { title: 'Scenariusz' },
  { title: 'Goście w środku' },
  { title: 'Data odczytu' },
  { title: 'Odczyt poprawny' },
  { title: 'Otwarte okna' },
  { title: availableZones?.zone_7_temperature ?? 'Sypialnia z oknem' },
  { title: availableZones?.zone_8_temperature ?? 'Sypialnia z balkonem' },
  { title: availableZones?.zone_9_temperature ?? 'Salon' },
  { title: availableZones?.zone_a_temperature ?? 'Łazienka' },
  { title: 'Błąd' },
  { title: '' },
]
